
import * as S from './styles';
import logo from 'images/logo-white.png';
import close from 'images/close.png';
// import check from 'images/check-circle.png';
import Form from 'components/Form';

function Footer({ showModal,setShowModal }) {
  return (
    <S.Wrapper className={showModal ? 'active' : ''}>
       <span className="modal-mask"></span>
       <S.Container>
          <img src={logo} alt="stm" className='modal-logo' />
          {/* <h3>How to Profit from Sweepstakes Affiliate Offers</h3>
          <p>Find out how Emil Alexandru, a member of Premium Affiliate Marketing Forum <br /><strong>STMForum.com</strong>, earns over $10,000/day by promoting sweepstakes offers! </p>
          <p className='red uppercase'><i>Download this free PDF to find out:</i></p>
          <ul>
            <li><img src={check} alt="" /><p>The secret to choosing which offers to promote (just this ONE secret will help you beat out 99% of the competition!)</p></li>
            <li><img src={check} alt="" /><p>The best place to buy traffic</p></li>
            <li><img src={check} alt="" /><p>How to insert some code to automatically increase ROI by 20-30% - with zero additional effort</p></li>
            <li><img src={check} alt="" /><p>How to find the best niches</p></li>
            <li><img src={check} alt="" /><p>Tips on ad creatives and landing page</p></li>
            <li><img src={check} alt="" /><p>And MUCH more!</p></li>
          </ul> */}
          <button className="close-btn" onClick={() => setShowModal (prev => !prev)}>
            <img src={close} alt="close" />
          </button>
          <Form />
       </S.Container>
    </S.Wrapper>
  );
}

export default Footer;
